/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2b41fb14&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2b41fb14&lang=css"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__